import { Component, OnInit } from '@angular/core';
import { ModelService } from 'src/app/services/model.service';
import { UserListService } from './user-list.service';
import { Router } from '@angular/router';
import { User } from 'src/app/entities/user.entity';
import { LoginService } from 'src/app/login/login_service/login.service';
import { Store } from '@ngrx/store';
import * as pathActions from '../../store/path/path.actions';
import * as listUsersActions from '../../store/listUsers/listUsers.actions';
import { AppState } from 'src/app/app.reducers';
import { ListUsersFilters } from '../../store/listUsers/listUsers.data';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-user-list',
	templateUrl: './user-list.component.html',
	styleUrls: ['./user-list.component.scss']
})
export class UserListComponent implements OnInit {

	//private path: pathValid = '/hold';
	private currentFilter = 1; // 1 Activos, 0 Desactivados, 2 espera, 3 Borrado.

	public currentPage = 0;
	public itemsByPage = 10;
	public totalPage = 0;
	public btnsPage = [];

	private SQLorder = { "apellidos": 1, "nombre": 1 };

	// Arreglo de subscribes, utilizado para liberarlos todos al mismo tiempo.
	private subscriptions: Subscription[] = [];

	constructor(
		private store: Store<AppState>,
		public modelService: ModelService,
		public userListService: UserListService,
		private router: Router,
		private loginService: LoginService) {
	}

	public ngOnInit(): void {

		this.store.subscribe(store => {
			//if (this.currentPage !== store.listUsers.currentPage || this.currentFilter !== store.listUsers.currentFilter) {
				this.currentPage = store.listUsers.currentPage;
				this.currentFilter = store.listUsers.currentFilter;
				//if(this.getPages())
				console.log("xxxxxxxxxxxxxxxxxxxxx");
				this.userListService.getCurrentList(this.currentFilter.toString(), this.SQLorder, this.currentPage, this.itemsByPage);
			//}
		});

		this.subscriptions.push(this.modelService.getUser().userChangeSignal.subscribe((value: string) => {
			console.log("xxxxx userChangeSignal");
			this.userListService.getCurrentList(this.currentFilter.toString(), this.SQLorder, this.currentPage, this.itemsByPage);
		}));

		this.loginService.isLoggedIn();
		var i = document.getElementById('webContents');
		if (i) i.setAttribute('style', "");
		//this.userListService.ge tList2();
		this.userListService.getCurrentList('1', this.SQLorder, 0, this.itemsByPage);
	}

	// Destructor.
	public ngOnDestroy(): void {
		// Liberar todos los subscribes.
		this.subscriptions.map((item: Subscription) => { item.unsubscribe(); });
	}

	// ______________________________________________________ BOTONES
	// Activar un usuario.
	public validateUser(user: User): void {
		user.estado = 1;
		this.userListService.validateUser(user);
	}

	// Desactivar un usuario.
	public removeUser(user: User): void {
		user.estado = 0;
		this.userListService.deactivateUser(user);
	}

	public get activeUsers(): number {
		return this.userListService.userList ? this.userListService.userList.filter((user) => {
			return user.estado === 1;
		}).length : 0;
	}

	// Editar usuario
	public editUser(user: User): void {
		//Utils.NAV_GoFront(' /user-list');
		this.store.dispatch(pathActions.goFront({ path: '/user-list' }));

		this.router.navigate(['/user-profile', user['_id']]);
		this.modelService.showDataUser.emit('OK');
	}

	// ______________________________________________________ INFORMACIÓN
	// Total usuarios.
	public get totalUsers(): number {
		return this.userListService.userList ? this.userListService.userList.length : 0;
	}

	// ______________________________________________________ FILTRO
	// UI actualiza los botones
	public isActive() { return this.currentFilter === ListUsersFilters.actives }
	public isDisable() { return this.currentFilter === ListUsersFilters.disables }
	public isWait() { return this.currentFilter === ListUsersFilters.waits }
	public isDelete() { return this.currentFilter === ListUsersFilters.deletes }

	public changeFilter(type: number) {
		if (type < 0 || type > 3) return;
		this.userListService.userList = [];
		this.store.dispatch(listUsersActions.setCurrentFilter({ filter: type }));
	}

	public addUser() {
		//this.store.dispatch(pathActions.goFront({ path: '/user-list' }));
		this.router.navigate(['/registerinter']);
	}

	public getTitle() {
		if (this.currentFilter === ListUsersFilters.actives) return this.modelService.getString('user_list_title_active');
		if (this.currentFilter === ListUsersFilters.disables) return this.modelService.getString('user_list_title_disabled');
		if (this.currentFilter === ListUsersFilters.waits) return this.modelService.getString('user_list_title_wait');
		return this.modelService.getString('user_list_title_delete');
	}

	// ______________________________________________________ PAGINACIÓN
	public getPages(): boolean {
		if (this.currentFilter === ListUsersFilters.actives) return this.calculatePages(this.userListService.activeUsers);
		if (this.currentFilter === ListUsersFilters.disables) return this.calculatePages(this.userListService.desactiveUsers);
		if (this.currentFilter === ListUsersFilters.waits) return this.calculatePages(this.userListService.waitUsers);
		return this.calculatePages(this.userListService.deleteUsers);
	}

	private calculatePages(count: number): boolean {
		// Mapeo de las páginas.
		this.btnsPage = [];

		// Si no hay registros salir con falso.
		if (count === 0) return false;

		// Obtener la cantidad de páginas.
		this.totalPage = Math.floor(count / this.itemsByPage);
		if ((count % this.itemsByPage) > 0) this.totalPage++;

		// En caso de superar siete páginas.
		let init = 0; // Principio.
		let end = this.totalPage;
		if (this.totalPage > 5) {
			if (this.currentPage > 2) {
				if (this.currentPage > (this.totalPage - 3)) {
					init = this.totalPage - 5; // Final.
				}
				else {
					init = this.currentPage - 2; // Centrado.
				}
			}
			end = init + 5;
		}

		for (let i = 0; i < end; i++) {
			this.btnsPage.push({ active: false, page: i, text: (i + 1).toString() });
		}

		return true;
	}

	// Ir a la página indicada.
	public paginate(page: number) {
		if (this.currentPage !== page && page > -1 && page < this.totalPage){
			this.store.dispatch(listUsersActions.setCurrentPage({ page: page }));
		}
	}

	// Retroceder a la página anterior.
	public nextPage() {
		if (this.currentPage < (this.totalPage - 1)) {
			this.store.dispatch(listUsersActions.setCurrentPage({ page: this.currentPage + 1 }));
		}
	}

	// Pasar a la siguiente página.
	public previousPage() {
		if (this.currentPage > 0) {
			this.store.dispatch(listUsersActions.setCurrentPage({ page: this.currentPage - 1 }));
		}
	}

	// Situarse en la última página.
	public lastPage() {
		if (this.currentPage < (this.totalPage - 1)) {
			this.store.dispatch(listUsersActions.setCurrentPage({ page: this.totalPage - 1 }));
		}
	}

	// Situarse en la primera página.
	public firstPage() {
		if (this.currentPage > 0) {
			this.store.dispatch(listUsersActions.setCurrentPage({ page: 0 }));
		}
	}
}
